import React from 'react'

export default function DownloadIcon({ color }) {
  const fillColor = typeof color === 'string' ? color : '#FFFFFF'
  return (
    <svg
      width="18px"
      height="17px"
      viewBox="0 0 18 17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="More"
          transform="translate(-16.000000, -16.000000)"
          fillRule="nonzero"
          fill={fillColor}
        >
          <path
            d="M23.7071,24.6555864 L23.7071,16 L25.7071,16 L25.7071,24.6155864 L27.9799932,22.3426932 L29.3942068,23.7569068 L24.6871,28.4640136 L19.9799932,23.7569068 L21.3942068,22.3426932 L23.7071,24.6555864 Z M20.1213136,31 L29.2928864,31 L31.9999932,28.2928932 L33.4142068,29.7071068 L30.1213136,33 L19.2928864,33 L15.9999932,29.7071068 L17.4142068,28.2928932 L20.1213136,31 Z"
            id="download"
          />
        </g>
      </g>
    </svg>
  )
}
